import { SYSBaseElement } from "../../../src"
import {
  HookSYSShellbarDisplayHint,
  HookSYSShellbarDisplayHint_ReturnType,
  HookSYSShellbarDisplayHint_Type,
} from "../hooks"

export class CompSYSShellbarHint extends SYSBaseElement {
  mode: "left" | "right"
  async init() {
    this.classList.add("fd-has-type-2")
    this.classList.add("fd-has-color-action-2")
    await super.init()
  }
  async getUI() {
    if (!this.state.ovl.app.ready) {
      return undefined
    }
    let fn =
      this.actions.app.features?.SYSShellbar?.hooks?.[
        HookSYSShellbarDisplayHint
      ]
    if (fn) {
      let res: HookSYSShellbarDisplayHint_ReturnType =
        await this.actions.app.features?.SYSShellbar?.hooks?.[
          HookSYSShellbarDisplayHint
        ]({ mode: this.mode } as HookSYSShellbarDisplayHint_Type)
      return res?.res
    } else {
      return undefined
    }
  }
}
